import React                             from 'react';
import { isNullOrUndefined }             from 'rewire-common';
import { Observe}                        from 'rewire-core';
import { ICell }                         from 'rewire-grid';
import { withStyles, Theme }             from 'rewire-ui';
import { TimecardTestStatusIcon }        from '../test/TimecardTestListCardView';
import { StyleType }                     from '../utility/styles';

const styles = (theme: Theme) => ({
  cellWrapper: {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'darkgray',
    fontSize: '16px',
    textAlign: 'center',
  },
  timecardTestStatusIcon: {
    fontSize: '1.5rem',
  },
  hasNoDifference: {
    color: theme.palette.success.light,
  },
  hasDifference: {
    color: theme.palette.error.main,
  },
  differenceValue1: {
    textDecoration: 'line-through',
    color: theme.palette.error.main,
    marginRight: '5px',
  },
  differenceValue2: {
    color: theme.palette.success.light,
  },
});

interface ICellProps {
  cell: ICell;
  classes: StyleType<typeof styles>;
}

export const DifferenceTotalRenderer: React.FunctionComponent<ICellProps> = React.memo(withStyles(styles, (props) => {
  return <Observe render={() => {
    const { cell, classes } = props;
    if (isNullOrUndefined(cell.value)) return null;
    const value = cell.column.map ? cell.column.map(cell.value) : cell.value;
    let differenceClass: string | undefined;
    if (cell.value > 0 || cell.value < 0) {
      differenceClass = classes.hasDifference;
    } else {
      differenceClass = classes.hasNoDifference;
    }
    return <span className={differenceClass}>{value}</span>;
  }} />;
}));

export const StatusIconRenderer: React.FunctionComponent<ICellProps> = React.memo(withStyles(styles, (props) => {
  return <Observe render={() => {
    const { cell, classes } = props;
    if (!cell.value) return null;
    return <div className={classes.cellWrapper}><TimecardTestStatusIcon status={cell.value} classes={{status: classes.timecardTestStatusIcon}} /></div>;
  }} />;
}));